"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Progress = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _LinearProgress = _interopRequireDefault(require("./LinearProgress"));
var _Wrapper = _interopRequireDefault(require("./Wrapper"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Progress = exports.Progress = function Progress(_ref) {
  var color = _ref.color,
    value = _ref.value,
    hidePercentage = _ref.hidePercentage,
    noMargin = _ref.noMargin,
    kind = _ref.kind;
  return /*#__PURE__*/_react["default"].createElement(_Wrapper["default"], {
    noMargin: noMargin,
    color: color,
    kind: kind
  }, /*#__PURE__*/_react["default"].createElement(_LinearProgress["default"], {
    color: color,
    kind: kind,
    value: value,
    variant: "determinate",
    noMargin: noMargin
  }), !hidePercentage && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    kind: "lighter"
  }, value, " %"));
};
Progress.propTypes = process.env.NODE_ENV !== "production" ? {
  kind: _propTypes["default"].oneOf(['inverse']),
  color: _propTypes["default"].any,
  value: _propTypes["default"].number,
  hidePercentage: _propTypes["default"].bool,
  noMargin: _propTypes["default"].bool
} : {};
Progress.defaultProps = {
  color: 'primary',
  value: 0,
  hidePercentage: false,
  noMargin: false
};
var _default = exports["default"] = Progress;